const TOKEN_NAME = 'gh_src';
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2)
        return parts.pop().split(';').shift() ?? null;
    return null;
}
function setCookie(name, value, days = 14) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value}; ${expires}; path=/; SameSite=Lax; Secure`;
}
function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax; Secure`;
}
export function captureGreenhouseSource() {
    const ghSrcToken = new URLSearchParams(window.location.search).get(TOKEN_NAME);
    if (ghSrcToken) {
        setCookie(TOKEN_NAME, ghSrcToken);
    }
}
export function appendGreenhouseSourceToUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has(TOKEN_NAME))
        return;
    const ghSrcToken = getCookie(TOKEN_NAME);
    if (ghSrcToken) {
        urlParams.set(TOKEN_NAME, ghSrcToken);
        const newUrl = `${window.location.pathname}?${urlParams.toString()}${window.location.hash}`;
        window.history.replaceState({ path: newUrl }, '', newUrl);
    }
}
// Called after Greenhouse confirms a successful application submission so the
// source is attributed exactly once and not carried into future applications.
export function clearGreenhouseSource() {
    deleteCookie(TOKEN_NAME);
}
